import { Link } from 'react-router-dom';

import { Button } from 'antd';

import PermissionHide from 'v2/components/Shared/PermissionHide';

import { Icon } from '@eduzz/ui-antd-theme';

const EditButton = ({
  id,
  parentId,
  disabled,
  onClick
}: {
  id: string;
  parentId?: string;
  disabled?: boolean;
  onClick?: () => void;
}) => {
  const isChild = !!parentId;
  const finalRoute = isChild
    ? `/producer/product/editproduct/${parentId}/${id}`
    : `/producer/product/editproduct/${id}`;

  return (
    <PermissionHide action='myeduzz:meus-produtos:editar'>
      <Link to={finalRoute} className='block w-full'>
        <Button
          id='quickview-product-edit-button'
          block
          color='default'
          variant='filled'
          onClick={onClick}
          disabled={disabled}
          icon={<Icon.Pencil />}
        >
          Editar
        </Button>
      </Link>
    </PermissionHide>
  );
};

export default EditButton;
